import React, { useState } from 'react';
import './index.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faTrophy, faLaptopCode, faChevronDown } from '@fortawesome/free-solid-svg-icons';

const ProfessionalSummary = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="professional-summary">
      <div className={`summary-card ${isExpanded ? 'expanded' : 'collapsed'}`}>
        <div className="summary-header" onClick={toggleExpanded}>
          <div className="header-content">
            <h3>Professional Summary</h3>
          </div>
          <FontAwesomeIcon 
            icon={faChevronDown} 
            className={`chevron-icon ${isExpanded ? 'rotated' : ''}`}
          />
        </div>

        {isExpanded && (
          <div className="summary-content">
            <p className="main-description">
              I am a dedicated full-stack developer with <strong>5+ years</strong> hands-on experience building web, mobile, and enterprise solutions across diverse environments. My engineering work at GE Appliances earned me <strong>4 U.S. patents</strong>, and my partnership-driven approach as a freelancer has helped startups and leaders launch scalable, user-focused products. With a natural sales acumen, I also achieved <strong>#1 nationwide</strong> awards at Charter Communications and excelled as a district manager.
            </p>
            
            <div className="achievements-row">
              <div className="achievement">
                <FontAwesomeIcon icon={faCertificate} color="#ffd700" size="2x" />
                <span className="number">4</span>
                <span className="label">U.S. Patents</span>
              </div>
              <div className="achievement">
                <FontAwesomeIcon icon={faTrophy} color="#ffd700" size="2x" />
                <span className="number">#1</span>
                <span className="label">Sales Nationwide</span>
              </div>
              <div className="achievement">
                <FontAwesomeIcon icon={faLaptopCode} color="#ffd700" size="2x" />
                <span className="number">5+</span>
                <span className="label">Years of Experience</span>
              </div>
            </div>

            <div className="skills-section">
              <div className="skills-grid">
                <div className="skill-category">
                  <strong>Programming Languages:</strong>
                  <span>.NET & C#, JavaScript/TypeScript, Python, Java, C/C++, Swift</span>
                </div>
                
                <div className="skill-category">
                  <strong>Frontend Technologies:</strong>
                  <span>React/React Native, Angular, Vue.js, HTML5, CSS3, SASS/SCSS, Bootstrap, Material-UI</span>
                </div>
                
                <div className="skill-category">
                  <strong>Backend & Frameworks:</strong>
                  <span>ASP.NET/ASP.NET Core, Node.js, Express.js, RESTful APIs, GraphQL, Microservices</span>
                </div>
                
                <div className="skill-category">
                  <strong>Cloud & DevOps:</strong>
                  <span>AWS, Azure, Docker, Kubernetes, CI/CD, Git/GitHub, Jenkins</span>
                </div>
                
                <div className="skill-category">
                  <strong>Databases:</strong>
                  <span>SQL Server, MongoDB, PostgreSQL, MySQL, Firebase Firestore, Redis</span>
                </div>
                
                <div className="skill-category">
                  <strong>Mobile Development:</strong>
                  <span>React Native, Xamarin, Swift (iOS), Android Development</span>
                </div>
                
                <div className="skill-category">
                  <strong>Specialized Technologies:</strong>
                  <span>IoT Development, AI/ML Integration, Real-time Applications, Web APIs</span>
                </div>
                
                <div className="skill-category">
                  <strong>Leadership & Business:</strong>
                  <span>Project Management, Client Relations, Sales Strategy, Team Collaboration, Agile/Scrum</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfessionalSummary;
